import { render, staticRenderFns } from "./AccessibilityFormComponent.vue?vue&type=template&id=229d370c&xmlns=true&"
import script from "./AccessibilityFormComponent.vue?vue&type=script&lang=js&"
export * from "./AccessibilityFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports